import { rem } from "polished";
import styled from "styled-components";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { ColorLabels } from "@/components/editor/utils/colors";

export const BackgroundColorWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors[ColorLabels.VISUALS_2]};
`;

export const SpeakerList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export const StyledFlex = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${rem(40)};

  .text-primitive {
    color: ${({ theme }) => theme.colors[ColorLabels.SECONDARY_FONT]};
  }
`;

export const PaddingWrapper = withViewportStyle("div")`
  padding: ${rem(80)} ${rem(24)};

  ${(props) => props.$viewport.mobile`
    padding: ${rem(40)} ${rem(16)};
  `}
`;
